
import { mapGetters, mapState } from 'vuex'
import baseLogic from '~/mixins/base-logic'
import cms from '~/mixins/common/cms'
export default {
    name: 'MyDeposit',
    mixins: [baseLogic, cms],
    data() {
        return {
            paymentType: 'bank',
            forceToAddBankAccountModal: false,
            disabledToDeposit: false,
            disabledBank: true,
            disabledThirdParty: true,
            disabledCrypto: true,
        }
    },
    computed: {
        ...mapGetters({
            depositInstruction: 'cms/depositInstruction',
            companyBankAccounts: 'themes/company-bank/companyBankAccount',
            // bannerDeposit: 'cms/bannerDeposit',
        }),
        ...mapState({
            player: (state) => state.player.player,
            depositFlow: (state) => state.themes.deposit.depositFlow,
            checkExist: (state) => state.themes.deposit.checkExist,
            checkDeposit: (state) => state.themes.deposit.checkDeposit,
            operationSetting: (state) => state.settings.operationSetting,
        }),
        depositType() {
            if (!this.depositFlow.deposit_type) return null
            return ~~this.depositFlow.deposit_type
        },
        showBankPayment() {
            if (this.depositType === 1) return false
            return this.depositFlow.is_bank_transfer_enabled
        },
        showOnlinePayment() {
            if (this.depositType === 1) return false
            return this.depositFlow.is_third_party_payment_enabled
        },
        showCryptoCurrency() {
            if (this.depositType === 1) return false
            return (
                this.depositFlow.is_crypto_payment_enabled ||
                ~~this.operationSetting?.reg_flow === 5
            )
        },
    },
    watch: {
        player(value) {
            this.checkWebsiteSettings()
        },
        depositFlow(value) {
            if (!this.paymentType) {
                if (value?.is_bank_transfer_enabled) {
                    this.paymentType = 'bank'
                } else if (value?.is_third_party_payment_enabled) {
                    this.paymentType = 'online'
                } else if (value?.is_crypto_payment_enabled) {
                    this.paymentType = 'crypto'
                }
            }
            // only international
            if (value?.reg_flow) {
                const hasBankAccount = this.player.has_bank_account
                if (
                    hasBankAccount === false &&
                    [2, 3].includes(value?.reg_flow)
                ) {
                    this.forceToAddBankAccountModal = true
                    this.disabledToDeposit = true
                }
            }
            // default selected payment type
            if (~~~value?.reg_flow === 5) {
                this.paymentType = 'crypto'
            }
        },
        operationSetting(value) {
            if (~~~value?.reg_flow === 5) {
                this.paymentType = 'crypto'
            }
        },
        checkExist(value) {
            if (value?.is_exist) {
                this.enableDisabledPaymentMethod(value)
            }
        },
        checkDeposit(value) {
            if (value) {
                this.disabledBank = true
                this.disabledThirdParty = true
                this.disabledCrypto = true
            }
        },
    },
    async mounted() {
        this.isExit()
        if (this.$cookie.get('token')) {
            this.$store.dispatch('settings/toggleIsLogin', true)
        }
        let params = {}
        // this is hardcoded section, since only VRU66 doesn't need currency params
        // Ask Mr Bank about this
        if (this.isInternational) {
            params = { currency: this.$cookie.get('player')?.currency }
        }
        // execute only lao wl
        if (!this.isInternational)
            await this.$store.dispatch(
                'themes/deposit/depositFlow',
                this.$cookie.get('player')?.currency
            )
        // execute only inter wl
        if (this.isInternational) {
            this.$store.dispatch(
                'settings/operationSetting',
                this.$cookie.get('player')?.currency
            )
        }
        await this.$store.dispatch(
            'themes/company-bank/getCompanyBankPlayerAccount',
            params
        )

        await this.$store.dispatch('themes/deposit/getThirdPartyPayments')
        this.checkWebsiteSettings()

        this.subscribeAction = this.$store.subscribeAction(
            (mutation, state) => {
                if (
                    mutation.type === 'sockets/revokeDepositByAdmin' ||
                    mutation.type === 'sockets/confirmDepositByAdmin' ||
                    mutation.type === 'sockets/successfulDeposit'
                ) {
                    this.isExit()
                }
            }
        )
        if (~~this.depositFlow.reg_flow === 5) {
            this.paymentType = 'crypto'
        }
    },
    beforeDestroy() {
        // unsubscribe the store action
        if (this.subscribeAction) {
            this.subscribeAction()
        }
    },
    methods: {
        checkWebsiteSettings() {
            const hasBankAccount = this.player.has_bank_account
            const registrationType = this.player.registration_type

            if (hasBankAccount === false && registrationType === 3) {
                this.forceToAddBankAccountModal = true
                this.disabledToDeposit = true
            }
        },
        async isExit() {
            const isExist = await this.$store.dispatch(
                'themes/deposit/checkExist'
            )
            this.enableDisabledPaymentMethod(isExist)
        },
        enableDisabledPaymentMethod(data) {
            if (
                data &&
                data.is_exist === true &&
                data.payment_provider_code === 'manual_transfer'
            ) {
                this.paymentType = 'bank'
                this.disabledBank = false
                this.disabledThirdParty = true
                this.disabledCrypto = true
            } else if (
                data &&
                data.is_exist === true &&
                data.payment_provider_code === 'crypto'
            ) {
                this.paymentType = 'crypto'
                this.disabledBank = true
                this.disabledThirdParty = true
                this.disabledCrypto = false
            } else if (
                data &&
                data.is_exist === true &&
                data.payment_provider_code === 'third_party'
            ) {
                this.paymentType = 'online'
                this.disabledBank = true
                this.disabledThirdParty = false
                this.disabledCrypto = true
            } else {
                this.disabledBank = false
                this.disabledThirdParty = false
                this.disabledCrypto = false
            }
        },
        copiedBankId(item) {
            try {
                setTimeout(() => {
                    this.copyAndOpenApp(item?.bank_account_number)
                }, 300)
                const playerBankAccountNumber = document.getElementById(
                    'playerBankAccountNumberTheme2'
                )
                navigator.clipboard.writeText(playerBankAccountNumber.innerText)
            } catch (error) {}
        },
    },
}
